import { IconHome, IconKey } from '@tabler/icons-react';
import { Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import { activeTab } from '../types/dashboard.types';

interface Props {
  activeTab: activeTab;
  onTabChange: (tab: activeTab) => void;
  // allCount: number
  preSaleCount: number;
  rentalSecondaryCount: number;
}

const NavigationTabDashboard = ({
  activeTab,
  onTabChange,
  preSaleCount,
  rentalSecondaryCount,
}: Props) => {
  return (
    <Card className="mb-4">
      <CardBody>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === 'rent-secondary' ? 'active' : ''}
              onClick={() => onTabChange('rent-secondary')}
              style={{ cursor: 'pointer' }}
            >
              <IconKey size={16} className="me-2" />
              Renta | Secondary ({rentalSecondaryCount})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === 'pre-sale' ? 'active' : ''}
              onClick={() => onTabChange('pre-sale')}
              style={{ cursor: 'pointer' }}
            >
              <IconHome size={16} className="me-2" />
              PreVenta ({preSaleCount})
            </NavLink>
          </NavItem>
        </Nav>
      </CardBody>
    </Card>
  );
};

export default NavigationTabDashboard;
